import React from "react";

export const ImagePreviewContext = React.createContext({
  setSelectedImage: (image: string | undefined) => {},
});

export const useImagePreviewContext = () => React.useContext(ImagePreviewContext);
